import React from 'react'
import { Button } from '@chakra-ui/react'
import type { ButtonProps } from '@chakra-ui/react'

export default function SharedButton({ children, ...props }: ButtonProps) {
    return (
        <Button
            rounded="full"
            h={getHeightForSize(props.size)}
            px={getPaddingXForSize(props.size)}
            {...props}
        >
            {children}
        </Button>
    )
}

function getHeightForSize(size: ButtonProps['size']) {
    switch (size) {
        case 'xs':
            return '28px'
        case 'sm':
            return '32px'
        case 'md':
            return '36px'
        case 'lg':
            return '40px'
        default:
            return undefined
    }
}

function getPaddingXForSize(size: ButtonProps['size']) {
    switch (size) {
        case 'xs':
            return 2
        case 'sm':
            return 3
        case 'md':
            return 4
        case 'lg':
            return 6
        default:
            return undefined
    }
}
